var parent = require('../../es/instance/sort');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/sort.js
// module id = 570
// module chunks = 0 1